import { z } from "zod";

export const siteSettingsSchema = z.object({
  brandName: z.string(),
  tagline: z.string(),
  whatsappNumber: z.string(),
  whatsappHours: z.string(),
  bookingEmail: z.string(),
  addressLines: z.array(z.string()),
  mapUrl: z.string(),
  lowSeasonRate: z.string(),
  highSeasonRate: z.string(),
  acceptBookings: z.boolean(),
  showIndonesian: z.boolean(),
  metaTitle: z.string(),
  metaDescription: z.string(),
  updatedAt: z.string(),
});
export type SiteSettings = z.infer<typeof siteSettingsSchema>;

export const siteSettingsUpdateSchema = siteSettingsSchema
  .omit({ updatedAt: true })
  .partial()
  .refine((value) => Object.keys(value).length > 0, "Nothing to update");
export type SiteSettingsUpdateInput = z.infer<typeof siteSettingsUpdateSchema>;

export const SEO_TITLE_LIMIT = 60;
export const SEO_DESCRIPTION_LIMIT = 160;
